import { Spinner } from '@chakra-ui/react';
import { TransactionProps } from '@common/react/transactions';
import { useTransactionProgressInfo } from '@common/react/transactions/useTransactionProgressInfo';
import { isNumber } from '@common/util/types';
import { FC } from 'react';
import VerticalProgressTrail from '../common/VerticalProgressTrail';

export interface TransactionProgressProps {
    transaction: TransactionProps;
}

const TransactionProgress: FC<TransactionProgressProps> = ({ transaction }) => {
    const progressInfo = useTransactionProgressInfo({
        transaction,
    });

    if (!progressInfo) {
        return <Spinner size="sm" color="gray.500" />;
    }

    const { stepConfigs, numberOfStepsCompleted } = progressInfo;

    if (!isNumber(numberOfStepsCompleted)) return null;

    return (
        <VerticalProgressTrail
            stepConfigs={stepConfigs}
            numberOfStepsCompleted={numberOfStepsCompleted}
        />
    );
};

export default TransactionProgress;
